<h2>Register</h2>
<form
  [formGroup]="registerForm"
  (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label for="firstName">First Name</label> <input
    type="text"
    formControlName="firstName"
    class="form-control"
    [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
  @if (submitted && f.firstName.errors) {
    <div
      class="invalid-feedback">
      @if (f.firstName.errors.required) {
        <div>First Name is required</div>
      }
    </div>
  }
</div>
<div class="form-group">
  <label for="lastName">Last Name</label> <input
  type="text"
  formControlName="lastName"
  class="form-control"
  [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
@if (submitted && f.lastName.errors) {
  <div
    class="invalid-feedback">
    @if (f.lastName.errors.required) {
      <div>Last Name is required</div>
    }
  </div>
}
</div>
<div class="form-group">
  <label for="username">Username</label> <input
  type="text"
  formControlName="username"
  class="form-control"
  [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
@if (submitted && f.username.errors) {
  <div
    class="invalid-feedback">
    @if (f.username.errors.required) {
      <div>Username is required</div>
    }
  </div>
}
</div>
<div class="form-group">
  <label for="password">Password</label> <input
  type="password"
  formControlName="password"
  class="form-control"
  [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
@if (submitted && f.password.errors) {
  <div
    class="invalid-feedback">
    @if (f.password.errors.required) {
      <div>Password is required</div>
    }
    @if (f.password.errors.minlength) {
      <div>Password must be at least 6 characters</div>
    }
  </div>
}
</div>
<div class="form-group">
  <button
    [disabled]="loading"
  class="btn btn-primary">Register</button>
  @if (loading) {
    <img
      class="pl-3"
			src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
}
		<a
			routerLink="/login"
  class="btn btn-link">Cancel</a>
</div>
</form>
